import { Link } from "react-router-dom";
import { useEffect } from "react";
import { Home, ArrowLeft, Phone } from "lucide-react";
import { Button } from "../components/ui/button";
import { BUSINESS } from "../data/regions";

const NotFoundPage = () => {
  useEffect(() => {
    document.title = "Page introuvable | KBR Toiture";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#0F172A] flex items-center justify-center px-4" data-testid="not-found-page">
      <div className="text-center max-w-lg">
        {/* 404 Number */}
        <div className="text-[180px] md:text-[220px] font-black leading-none text-[#C2410C]/20 font-['Barlow_Condensed'] select-none">
          404
        </div>

        <div className="-mt-16 relative z-10">
          <h1 className="text-3xl md:text-4xl font-bold text-white uppercase tracking-tight font-['Barlow_Condensed'] mb-4">
            Page introuvable
          </h1>
          <p className="text-white/60 mb-8 leading-relaxed">
            La page que vous recherchez n'existe pas ou a été déplacée. 
            Pas d'inquiétude, vous pouvez revenir à l'accueil ou nous contacter directement.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/">
              <Button className="bg-[#C2410C] hover:bg-[#9A3412] h-12 px-6 uppercase font-bold tracking-wider text-white">
                <Home className="mr-2 w-4 h-4" />
                Retour à l'accueil
              </Button>
            </Link>
            <a href={BUSINESS.phoneLink}>
              <Button variant="outline" className="h-12 px-6 uppercase font-bold tracking-wider text-white border-white/30 hover:bg-white hover:text-[#0F172A]">
                <Phone className="mr-2 w-4 h-4" />
                Nous appeler
              </Button>
            </a>
          </div>

          {/* Quick links */}
          <div className="mt-12 flex flex-wrap justify-center gap-4 text-sm">
            <Link to="/" className="text-white/40 hover:text-[#C2410C] transition-colors">Yvelines (78)</Link>
            <span className="text-white/20">|</span>
            <Link to="/haute-savoie" className="text-white/40 hover:text-[#C2410C] transition-colors">Haute-Savoie (74)</Link>
            <span className="text-white/20">|</span>
            <Link to="/mentions-legales" className="text-white/40 hover:text-[#C2410C] transition-colors">Mentions légales</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
